import { useState } from "react";
import { UserRegister } from "../models/userModel";
import { registerUser } from "../services/authService";
import "../assets/RegisterPage.css"
import React from 'react';


export const CreateUserPage = () => {
  const [username, setUsername] = useState('');
  const [first_name, setFirstName] = useState('');
  const [last_name, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  const [address, setAddress] = useState('');
  const [city, setCity] = useState('');
  const [country, setCountry] = useState('');

  const register = async () => {
    try {
      const user: UserRegister = {
        username,
        first_name,
        last_name,
        email,
        mobile,
        password,
        address,
        city,
        country,
      };
  
      await registerUser(user);
  
      alert('Registration successful!');
  
      setUsername('');
      setFirstName('');
      setLastName('');
      setEmail('');
      setMobile('');
      setPassword('');
      setAddress('');
      setCity('');
      setCountry('');
    } catch (error) {
      console.error("Error with registration:", error);
      
      if (error instanceof Error) {
        if (error.message.includes("Email")) {
          setEmail('');
        }
  
        if (error.message.includes("Username")) {
          setUsername('');
        }
      } 
    }
  };
  

  return (
    <>
    <div className="register-container">
        <div className="register-right">
            <h1 className="register-title">Create an Account</h1>
            <p className="register-subtitle">Expand our community</p>

            <form className="register-form" onSubmit={(e) => { e.preventDefault(); register(); }}>
                <div className="register-input-group">
                    <label htmlFor="username" className="register-label">Username</label>
                    <input
                    type="text"
                    id="username"
                    name="username"
                    className="register-input"
                    placeholder="Username"
                    value={username}
                    onChange={(event) => setUsername(event.target.value)}
                    required
                    />
                </div>
                <div className="register-input-group">
                    <label htmlFor="first_name" className="register-label">First Name</label>
                    <input
                    type="text"
                    id="first_name"
                    name="first_name"
                    className="register-input"
                    placeholder="First Name"
                    value={first_name}
                    onChange={(event) => setFirstName(event.target.value)}
                    required
                    />
                </div>

                <div className="register-input-group">
                    <label htmlFor="last_name" className="register-label">Last Name</label>
                    <input
                    type="text"
                    id="last_name"
                    name="last_name"
                    className="register-input"
                    placeholder="Last Name"
                    value={last_name}
                    onChange={(event) => setLastName(event.target.value)}
                    required
                    />
                </div>

                <div className="register-input-group">
                    <label htmlFor="email" className="register-label">Email</label>
                    <input
                    type="email"
                    id="email"
                    name="email"
                    className="register-input"
                    placeholder="example@email.com"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    required
                    />
                </div>

                <div className="register-input-group">
                    <label htmlFor="address" className="register-label">Address</label>
                    <input
                    type="text"
                    id="address"
                    name="address"
                    className="register-input"
                    placeholder="Address"
                    value={address}
                    onChange={(event) => setAddress(event.target.value)}
                    required
                    />
                </div>

                <div className="register-input-group">
                    <label htmlFor="city" className="register-label">City</label>
                    <input
                    type="text"
                    id="city"
                    name="city"
                    className="register-input"
                    placeholder="City"
                    value={city}
                    onChange={(event) => setCity(event.target.value)}
                    required
                    />
                </div>

                <div className="register-input-group">
                    <label htmlFor="country" className="register-label">Country</label>
                    <input
                    type="text"
                    id="country"
                    name="country"
                    className="register-input"
                    placeholder="Country"
                    value={country}
                    onChange={(event) => setCountry(event.target.value)}
                    required
                    />
                </div>

                <div className="register-input-group">
                    <label htmlFor="mobile" className="register-label">Mobile</label>
                    <input
                    type="tel"
                    id="mobile"
                    name="mobile"
                    className="register-input"
                    placeholder="Mobile"
                    value={mobile}
                    onChange={(event) => setMobile(event.target.value)}
                    required
                    />
                </div>

                <div className="register-input-group">
                    <label htmlFor="password" className="register-label">Password</label>
                    <input
                    type="password"
                    id="password"
                    name="password"
                    className="register-input"
                    placeholder="Password"
                    value={password}
                    onChange={(event) => setPassword(event.target.value)}
                    required
                    />
                </div>
            </form>
          <label className="register-link">I accept the <a href="/privacy-policy">Privacy Policy</a></label>
          <button type="button" onClick={register} className="register-button">Register</button>
      </div>
    </div>
    </>
  );
};


